import { render, staticRenderFns } from "./TableMemberTypesActive.vue?vue&type=template&id=57ef99bb&"
import script from "./TableMemberTypesActive.vue?vue&type=script&lang=js&"
export * from "./TableMemberTypesActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports